/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { map } from "lodash";

/**
 * Internal dependencies
 */
import ReportListGrid from "./report-list-grid";

/**
 * Style dependencies
 */
import "./styles.scss";

const FilterableReportList = ({ reports }) => {
  return (
    <Box>
      <Box className="reports__report-list-wrapper">
        <ReportListGrid
          reports={map(reports, (report) => ({
            key: report.id,
            ...report,
          }))}
        />
      </Box>
    </Box>
  );
};

export default FilterableReportList;
